// "Finish line": two bursts of brand-colour confetti for a passed theory test. canvas-confetti
// is a lazy chunk, fetched the first time a test is passed, and never under reduced motion.
import type { NgZone } from '@angular/core';
import { BRAND } from '../brand/brand-colors';
import { isMobileViewport, prefersReducedMotion } from './motion-env';

type Confetti = typeof import('canvas-confetti');

let api: Confetti | null = null;
/** Bumped by resetConfetti(), so a celebration still loading its chunk is dropped. */
let generation = 0;

export async function celebrate(zone: NgZone): Promise<void> {
  if (prefersReducedMotion()) return;
  const run = generation;
  await zone.runOutsideAngular(async () => {
    const { default: confetti } = await import('canvas-confetti');
    // The page may have moved on, or reduced motion been switched on, while the chunk loaded.
    if (run !== generation || prefersReducedMotion()) return;
    api = confetti;
    const base: Parameters<Confetti>[0] = {
      particleCount: isMobileViewport() ? 40 : 70,
      spread: 55,
      startVelocity: 48,
      ticks: 220,
      gravity: 1.1,
      scalar: 0.9,
      // Above the modal (1000), below ngx-scrolltop (10000); the canvas ignores pointer events.
      zIndex: 1100,
      colors: [BRAND.purple, BRAND.purple80, BRAND.purple50, BRAND.green, BRAND.white],
      disableForReducedMotion: true,
    };
    confetti({ ...base, angle: 60, origin: { x: 0, y: 0.75 } });
    confetti({ ...base, angle: 120, origin: { x: 1, y: 0.75 } });
  });
}

/** Stops any confetti in flight and removes its canvas. */
export function resetConfetti(): void {
  generation++;
  api?.reset();
}
